import getDisplayName from '@lib/utils/getDisplayName';
import useService from '@modules/ServiceModule/useService';
import useTasks from '@modules/TasksModule/hooks/useTasks';
import { IncomingCallToastType } from '@modules/ToastModule/types';
import { Toast } from '@servicetitan/design-system';
import classNames from 'classnames';
import { CallNotification } from './CallNotification';
import styles from './CallNotificationToast.module.css';
import { FeatureFlagKeys, useFeatureFlags } from '@modules/FeatureFlagModule';
import useTenantName from '@lib/hooks/useTenantName';
import useVoiceTask from '@modules/TasksModule/hooks/useVoiceTask';

const TOAST_DURATION = 60_000 * 60; // 1 hour
export type CallNotificationToastProps = IncomingCallToastType;

export const CallNotificationToast = ({ id }: CallNotificationToastProps) => {
  const { userByContactCenterUserId } = useService();
  const {
    [FeatureFlagKeys.featureShowCompanyNameForTenant]:
      featureShowCompanyNameForTenant,
  } = useFeatureFlags();
  const { tasks } = useTasks();

  const task = tasks.find(
    (task) => task.attributes?.callId === id || task.id === id,
  );

  const { isExternal, isInternal } = useVoiceTask(task);
  const tenantId = task?.tenantId ?? '';
  const tenantName = useTenantName(tenantId);

  if (!task) {
    return null;
  }

  const { displayName, from } = task;

  const callFrom = getDisplayName(
    displayName || from,
    userByContactCenterUserId,
  );

  let title = `Incoming Call from ${callFrom}`;
  if (featureShowCompanyNameForTenant) {
    if (isInternal) {
      title = `Incoming Call from ${callFrom} (Internal)`;
    } else if (isExternal && !!tenantName) {
      title = `Incoming Call from ${callFrom} (${tenantName})`;
    }
  }

  return (
    <Toast
      className={classNames(styles.callNotificationToast, 'p-2')}
      title={title}
      duration={TOAST_DURATION}
    >
      <CallNotification taskId={id} />
    </Toast>
  );
};
